import React from 'react'

export const Watermark = () => {
  return (
    <div></div>
  )
}
